require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-rates-credit-card-rates.json") })
        }
      }, "path---es-rates-credit-card-rates");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-rates-credit-card-rates!./.cache/json/es-rates-credit-card-rates.json
// module id = 2606
// module chunks = 231608221292675